import api from './api';

export type IncidentType = 'dispute' | 'refund' | 'payout_failed';
export type IncidentResolution = 'open' | 'recovered' | 'written_off' | 'no_action_needed';

export interface StripeIncident {
  id: string;
  incident_type: IncidentType;
  invoice_id: string | null;
  invoice_number: string | null;
  invoice_total: string | null;
  professional_id: string | null;
  professional_name: string | null;
  stripe_object_id: string;
  stripe_payment_intent_id: string | null;
  stripe_charge_id: string | null;
  stripe_account_id: string | null;
  amount: string;
  currency: string;
  reason: string | null;
  stripe_status: string | null;
  resolution: IncidentResolution;
  resolution_notes: string | null;
  resolved_at: string | null;
  created_at: string;
}

export const fetchStripeIncidents = (scope: 'open' | 'alles' = 'open') =>
  api.get('/admin/stripe/incidents', { params: { scope } });

export const resolveStripeIncident = (
  incidentId: string,
  resolution: IncidentResolution,
  resolutionNotes?: string
) =>
  api.patch(`/admin/stripe/incidents/${incidentId}`, {
    resolution,
    resolution_notes: resolutionNotes ?? null,
  });
